<div class="wrapper">
  <div class="sidebar" data-color="white" data-active-color="danger">
    <sidebar></sidebar>
  </div>
  <div class="main-panel">
    <navbar-admin></navbar-admin>
    <!-- <tabs-superadmin></tabs-superadmin> -->
    <alert></alert>
    <!-- <tabs-superadmin></tabs-superadmin> -->
    <div
      *ngIf="menuItems && menuItems.length > 0"
      #tabs
      class="nav-tabs-navigation"
    >
      <div class="nav-tabs-wrapper">
        <ul id="tabs" class="nav nav-tabs" role="tablist">
          <li class="nav-item" *ngFor="let menuitem of menuItems">
            <a
              class="nav-link"
              data-toggle="tab"
              [routerLink]="menuitem.path"
              routerLinkActive="active"
              role="tab"
              aria-expanded="true"
            >
              {{ menuitem.title | translate }}</a
            >
          </li>
        </ul>
      </div>
    </div>
    <router-outlet></router-outlet>
    <footer-cmp></footer-cmp>
  </div>
</div>
